var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"h-100 border-0"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h5',[_vm._v(" "+_vm._s(_vm.post.title)+" ")]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }